import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import React from 'react';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';
import {useTranslation} from 'react-i18next';

import {trackEvent} from '@explorer/analytics';

const step = 1 / 100;

const CompareDiff = ({range, onChange}) => {
  const {t} = useTranslation();

  const onRangeChange = (_, values) => {
    onChange(values);
  };

  const onAfterChange = (_, values) => {
    trackEvent('Compare Mode', {
      action: 'Pixel diffing threshold changed',
      values,
    });
  };

  return (
    <Box display="flex" alignItems="center">
      <Typography variant="body2">
        {t('common:threshold', 'Threshold')}
      </Typography>
      <Slider
        size="small"
        sx={{
          ml: 3,
          mb: 0.5,
          minWidth: 200,
        }}
        max={1}
        min={0}
        onChange={onRangeChange}
        onChangeCommitted={onAfterChange}
        step={step}
        value={range}
        valueLabelDisplay="auto"
        valueLabelFormat={val => `${Math.round(val * 100)}%`}
        marks={[
          {value: 0, label: '0%'},
          {value: 1, label: '100%'},
        ]}
      />
    </Box>
  );
};

CompareDiff.propTypes = {
  range: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CompareDiff;
